"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoboxMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const InfoboxMenuItem_1 = __importDefault(require("../../atoms/InfoboxMenuItem"));
const constants_1 = require("../../constants");
const hooks_1 = require("../../hooks");
const selectAvailableTabs_1 = require("../../selectors/selectAvailableTabs");
const utils_1 = require("../../utils");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
function InfoboxMenu({ onItemClick, currentTab }) {
    const isLower = (0, ui_1.useScreenBreakpoint)(ui_1.sizeMainScreen.tablet);
    const { scrollContainerRef, canScrollLeft, canScrollRight, startScrolling, stopScrolling, } = (0, ui_1.useScrollButtons)();
    const isItemSelected = currentTab !== null;
    const infoboxControls = (0, hooks_1.useInfoBoxControlsState)();
    const availableTabs = (0, hooks_1.useSelector)(selectAvailableTabs_1.selectAvailableTabs);
    const touchStartX = (0, react_1.useRef)(0);
    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };
    const handleTouchMove = (e) => {
        if (!scrollContainerRef.current)
            return;
        const deltaX = touchStartX.current - e.touches[0].clientX;
        scrollContainerRef.current.scrollLeft += deltaX;
        touchStartX.current = e.touches[0].clientX;
    };
    const onClick = (type) => {
        return () => {
            onItemClick(type);
        };
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'InfoboxMenu_Container', children: [isLower && canScrollLeft && ((0, jsx_runtime_1.jsx)(ButtonContainer, { direction: "left", "data-e2e": 'InfoboxMenu_ButtonContainer', children: (0, jsx_runtime_1.jsx)(ui_1.DirectionButton, { direction: "left", onMouseDown: () => startScrolling('left'), onMouseUp: stopScrolling, onMouseLeave: stopScrolling, "data-e2e": 'InfoboxMenu_DirectionButton' }) })), (0, jsx_runtime_1.jsx)(MenuItems, { ref: scrollContainerRef, isItemSelected: isItemSelected, canScrollLeft: canScrollLeft, canScrollRight: canScrollRight, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, "data-e2e": 'InfoboxMenu_MenuItems', children: Object.entries(i18n_1.Strings.infoBox.tabs)
                    .filter(([key, _]) => {
                    return (key !== 'Isolate' ||
                        (key === 'Isolate' && infoboxControls.enableIsolate >= 0));
                })
                    .map(([key, text]) => {
                    const type = (0, utils_1.getInfoboxTabType)(key);
                    if (!availableTabs.includes(type))
                        return;
                    return ((0, jsx_runtime_1.jsx)(InfoboxMenuItem_1.default, { text: text, icon: (0, constants_1.getTabIconByType)(type), isSelected: type === currentTab, onClick: onClick(type), "data-e2e": 'InfoboxMenu_InfoboxMenuItem' }, key));
                }) }), isLower && canScrollRight && ((0, jsx_runtime_1.jsx)(ButtonContainer, { direction: "right", "data-e2e": 'InfoboxMenu_ButtonContainer', children: (0, jsx_runtime_1.jsx)(ui_1.DirectionButton, { direction: "right", onMouseDown: () => startScrolling('right'), onMouseUp: stopScrolling, onTouchStart: () => startScrolling('right'), onTouchEnd: stopScrolling, onMouseLeave: stopScrolling, "data-e2e": 'InfoboxMenu_DirectionButton' }) }))] }));
}
exports.InfoboxMenu = InfoboxMenu;
const Container = styled_components_1.default.div `
  padding-right: 4px;
  height: 100%;
  width: 100%;
  position: relative;

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    display: flex;
    align-items: center;
    padding-right: 0;

    width: 100%;
  `)};
`;
const MenuItems = styled_components_1.default.div `
  padding: 16px 8px;
  height: 100%;
  background-color: inherit;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.grasshopper.background};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.grasshopper.descriptionPanel.scroll.idle};
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb:hover {
    opacity: 0.8;
  }

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    padding: 0;
    padding-bottom: 4px;
    margin: 0 16px;
    flex-direction: row;
    gap: 8px;
    overflow: hidden;
    background-color: none;
  `)};

  ${({ isItemSelected }) => isItemSelected &&
    (0, styled_components_1.css) `
      ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
        border-bottom: 1px solid
          ${({ theme }) => theme.grasshopper.borders.grey};
      `)};
    `}

  ${({ canScrollLeft }) => canScrollLeft &&
    (0, styled_components_1.css) `
      ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
        padding-left: 16px;
        margin-left: 0;
      `)};
    `}

    ${({ canScrollRight }) => canScrollRight &&
    (0, styled_components_1.css) `
      ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
        padding-right: 16px;
        margin-right: 0;
      `)};
    `}
`;
const ButtonContainer = styled_components_1.default.div `
  padding: 10px;
  z-index: 2;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: ${({ theme }) => theme.grasshopper.background};

  ${({ direction, theme }) => direction === 'left'
    ? `left: 0; box-shadow: 20px 0px 16px 0px ${theme.grasshopper.background}CC;`
    : `right: 0; box-shadow: -20px 0px 16px 0px ${theme.grasshopper.background}CC;`}
`;
